import { authHeader } from '../_helpers';
import axios from 'axios';

export const UploadDemographicService = {
    uploadCsvService
}

axios.defaults.headers.common = authHeader();

function uploadCsvService(data) {
    return axios.post('/users/upload/demograpic/data/', data)
    .then(response => {
        return response;
    });
}


// WEBPACK FOOTER //
// ./src/_services/UploadDemographicService.service.js